import React, { ReactElement, useState } from "react";
import Modal from "../../modal";
import Link from "../../link";
import { AgentDisclaimerProps } from "./AgentDisclaimer.types";

export const AgentDisclaimer = ({
  isFullScreen = false,
  modalContent,
  modalTitle = "AI answers may have errors",
  line1Text = "AI answers may have errors, please verify.",
  line2Text = "See our Privacy Statement and click for more.",
}: AgentDisclaimerProps): ReactElement => {
  const [open, setOpen] = useState(false);
  const handleClose = (): void => {
    setOpen(false);
  };
  const handleOpen = (
    e: React.MouseEvent<HTMLAnchorElement, MouseEvent>
  ): void => {
    e.preventDefault();
    setOpen(true);
  };

  return (
    <>
      <div style={{ textAlign: "center", fontSize: 13, lineHeight: 1.3 }}>
        <>
          {!isFullScreen ? (
            <>
              {line1Text}
              <br />
            </>
          ) : null}
          <Link onClick={handleOpen} href="/" underline>
            {isFullScreen ? `${line1Text} ` : null}
            {line2Text}
          </Link>
        </>
      </div>
      <Modal onClose={handleClose} open={open} title={modalTitle}>
        {modalContent}
      </Modal>
    </>
  );
};
